module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_8023.5bd0eaf9.png";